// A $( document ).ready() block.

(function($) {
  $( document ).ready(function() {
    $(document).on('click', '.shopsmart-open', function(e) {
      $(this).parents('.cart-modal').find('.modal-close').click();
    })
  });
}( jQuery ) );